var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "scatter-plot-content" }, [
    _vm.colorLegend.length > 0
      ? _c(
          "div",
          { staticClass: "plot-legend" },
          _vm._l(_vm.colorLegend, function (entry) {
            return _c(
              "div",
              {
                key: entry.value,
                staticClass: "legend-item",
                on: {
                  mouseenter: function ($event) {
                    _vm.hoveredLegendValue = entry.value
                  },
                  mouseleave: function ($event) {
                    _vm.hoveredLegendValue = null
                  },
                },
              },
              [
                _c("span", {
                  staticClass: "legend-dot",
                  style: { backgroundColor: entry.color },
                }),
                _c("span", [_vm._v(_vm._s(entry.value))]),
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _c("div", {
      staticClass: "clicked-dot-value hidden",
      attrs: { id: "clicked_dot_value" + _vm.sectionId },
    }),
    _c(
      "div",
      { staticClass: "scatter-plots-row" },
      _vm._l(_vm.resolvedPlots, function (plot, plotIndex) {
        return _c(
          "div",
          {
            key: _vm.plotPanelKey(plot, plotIndex),
            staticClass: "scatter-plot-panel",
          },
          [
            !!plot.renderConfig
              ? _c("canvas", {
                  staticClass: "scatter-plot",
                  style: _vm.canvasStyle(plot.renderConfig),
                  attrs: {
                    id: _vm.canvasId(plotIndex),
                    width: plot.renderConfig.width * 2 + 240,
                    height: plot.renderConfig.height * 2 + 240,
                  },
                  on: {
                    mouseleave: _vm.onCanvasMouseLeave,
                    mousemove: function ($event) {
                      return _vm.checkPosition($event, plotIndex)
                    },
                  },
                })
              : _vm._e(),
            _c("div", { staticClass: "download-images-setting" }, [
              _c(
                "span",
                { staticClass: "btn btn-default options-gear" },
                [
                  _vm._v(" Download "),
                  _c("b-icon", { attrs: { icon: "download" } }),
                ],
                1
              ),
              _c("ul", { staticClass: "options" }, [
                _c("li", [
                  _c(
                    "a",
                    {
                      attrs: { href: "javascript:;" },
                      on: {
                        click: function ($event) {
                          _vm.downloadImage(
                            _vm.canvasId(plotIndex),
                            _vm.downloadName(plotIndex),
                            "png"
                          )
                        },
                      },
                    },
                    [_vm._v("Download PNG")]
                  ),
                ]),
              ]),
            ]),
            plot.title
              ? _c("div", { staticClass: "scatter-plot-title" }, [
                  _vm._v(" " + _vm._s(plot.title) + " "),
                ])
              : _vm._e(),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }